import React, { useEffect, useState, useCallback } from "react";
import { useOutletContext } from "react-router-dom";
import { Header } from "../components/Sidebar";
import api from "../lib/api";
import { formatGs } from "../lib/format";
import { FileText, Eye } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../components/ui/dialog";
import { SearchBox, matchQ } from "../components/SearchBox";

export default function Documentos() {
  const { setMobileOpen } = useOutletContext();
  const [envios, setEnvios] = useState([]);
  const [sel, setSel] = useState(null);
  const [q, setQ] = useState("");
  const load = useCallback(() => {
    api.get("/envios?status=entregado").then(({ data }) => setEnvios(data.filter((e) => e.comprobante))).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <>
      <Header title="Documentos" subtitle="Comprobantes de entrega firmados" onMenu={() => setMobileOpen(true)} />
      <main className="p-4 sm:p-6 lg:p-8">
        <SearchBox value={q} onChange={setQ} placeholder="Buscar por código, destinatario o receptor…" testid="docs-search" />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {envios.filter(matchQ(q)).map((e) => (
            <div key={e.id} className="bg-white rounded-xl border border-[#E2E8F0] p-5 shadow-sm">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-lg bg-blue-50 border border-blue-100 flex items-center justify-center"><FileText className="h-5 w-5 text-[#3B82F6]" /></div>
                <div><div className="font-bold text-[#0A1F44]">{e.code}</div><div className="text-xs text-[#64748B]">{e.destinatario}</div></div>
              </div>
              <div className="mt-3 text-xs text-[#64748B]">Recibido por <b className="text-[#0A1F44]">{e.comprobante?.receptor}</b></div>
              <div className="mt-1 text-xs text-[#64748B]">{e.comprobante?.at ? new Date(e.comprobante.at).toLocaleString("es-PY") : ""}</div>
              <button onClick={() => { setSel(e); api.get(`/envios/${e.id}`).then(({ data }) => setSel(data)).catch(() => {}); }} data-testid={`ver-comprobante-${e.code}`} className="mt-3 w-full flex items-center justify-center gap-2 text-xs font-semibold border border-slate-300 rounded-lg py-2 hover:bg-slate-50"><Eye className="h-4 w-4" /> Ver comprobante</button>
            </div>
          ))}
          {envios.length === 0 && <div className="col-span-full text-center py-12 text-[#64748B] bg-white rounded-xl border border-[#E2E8F0]">No hay comprobantes registrados.</div>}
        </div>
      </main>
      <Dialog open={!!sel} onOpenChange={() => setSel(null)}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader><DialogTitle className="font-display">Comprobante {sel?.code}</DialogTitle><DialogDescription>Entrega registrada.</DialogDescription></DialogHeader>
          {sel && (
            <div className="space-y-3">
              <div className="flex justify-between text-sm"><span className="text-[#64748B]">Recibido por</span><b className="text-[#0A1F44]">{sel.comprobante?.receptor}</b></div>
              <div className="flex justify-between text-sm"><span className="text-[#64748B]">Cobrado</span><b className="text-[#0A1F44]">{formatGs(sel.monto_cobrado || 0)}</b></div>
              {sel.comprobante?.firma && <div><div className="text-xs text-[#64748B] mb-1">Firma</div><img src={sel.comprobante.firma} alt="firma" className="w-full h-32 object-contain rounded-lg border border-slate-200 bg-white" /></div>}
              {sel.comprobante?.foto && <div><div className="text-xs text-[#64748B] mb-1">Foto</div><img src={sel.comprobante.foto} alt="foto" className="w-full max-h-48 object-contain rounded-lg border border-slate-200" /></div>}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
